<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <!-- <div class="swiper-slide" data-hash="slide1"><img src="/static/images/banner.png" alt=""></div> -->
            <div class="swiper-slide" data-hash="slide2"><img src="/static/images/banner.png" alt=""></div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
    </div>

</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
    export default {
        data () {
            return {

            }
        },
        mounted() {
          var mySwiper = new Swiper ('.swiper-container', {
              loop: true, // 循环模式选项
              // autoplay:true,//等同于以下设置
              // 如果需要分页器
              // pagination: {
              //   el: '.swiper-pagination',
              //   clickable: true,
              // },
            })
        }
    }
</script>
<style >
.swiper-container {
  width: 100%;
  height: auto;
  /* top: -15px; */
}
.swiper-slide img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/index/Banner.vue